import PriceFacade, { PriceAdapters } from 'Favourites/helpers/PriceFacade';
import { selectProduct } from 'Favourites/store/reducers/data/products';
import { connect } from 'react-redux';

const mapStateToProps = (state, ownProps) => {
    const price = new PriceFacade();
    price.setState(state);
    price.setProductId(ownProps.article);

    price.setAdapter(PriceAdapters.RetailItemComm);

    if (ownProps.type === 'regular') {
        price.setPriceType(price.getAdapter().REGULAR_TYPE);
    }
    if (ownProps.type === 'family') {
        price.setPriceType(price.getAdapter().FAMILY_TYPE);
    }
    if (ownProps.type === 'discount') {
        price.setPriceType(price.getAdapter().DISCOUNT_TYPE);
    }
    if (ownProps.type === 'regularfamilyprice') {
        price.setPriceType(price.getAdapter().REGULAR_FAMILY_TYPE);
    }

    return {
        breathTakingItem: selectProduct(state, ownProps.article).breathTakingItem,
        unitPriceText: selectProduct(state, ownProps.article).unitPriceText,
        unitPrice: price.getUnitPrice(),
        totalPrice: price.getTotalProductPrice(),
        oldPrice: price.getOldPrice(),
        isTRO: price.isTRO(),
        isNLP: price.isNLP(),
        ValidToDateTime: price.getPriceExpirationDate(),
    };
};

export default connect(mapStateToProps);
